import React from 'react'
import { DatadogProvider } from '@datadog/openfeature-browser'
import { OpenFeature, OpenFeatureProvider } from '@openfeature/react-sdk'
import { ReactNode, useEffect } from 'react'
import { useCartAuth } from '@cartdotcom/auth'

// Initialize provider once (outside component — runs once at module load)
const datadogProvider = new DatadogProvider({
  applicationId: process.env.NX_DATADOG_APPLICATION_ID as string,
  clientToken: process.env.NX_DATADOG_CLIENT_TOKEN as string,
  site: 'datadoghq.com',
  env: process.env.NX_DATADOG_ENV as string,
})

OpenFeature.setProvider(datadogProvider)

export const FeatureFlagProvider = ({ children }: { children: ReactNode }) => {
  const { userId, email } = useCartAuth()

  useEffect(() => {
    if (!userId) return
    OpenFeature.setContext({
      targetingKey: `user-${userId}`,
      user_id: userId,
      email: email,
    })
  }, [userId, email])

  if (!userId) {
    return <>{children}</>
  }

  return <OpenFeatureProvider>{children}</OpenFeatureProvider>
}
